import type { OnInit } from '@angular/core';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import type { CalculateFeeMegaResponse } from '../services/interfaces/calculate-fee-mega-response';

@Component({
  standalone: false,
  selector: 'invd-review-mega-pricing',
  templateUrl: './review-mega-pricing.component.html',
  styleUrls: ['./review-mega-pricing.component.scss'],
})
export class ReviewMegaPricingComponent implements OnInit {
  @Input() calcFeeRes: CalculateFeeMegaResponse;
  @Input() isEditMegaFlow = false;
  public hidePricingWindow: boolean;
  public goBackAndEdit: boolean;
  public megaTypeDesc = '';
  public isSFFIXMega = false;

  @Output()
  clickAccept = new EventEmitter<any>();

  @Output()
  editPricingMegaClicked = new EventEmitter<any>();

  ngOnInit() {
    if (this.calcFeeRes && this.calcFeeRes.megaType === 'SFFIXMEGA') {
      this.megaTypeDesc = ' Single Family Fixed Rate';
      this.isSFFIXMega = true;
    } else if (this.calcFeeRes && this.calcFeeRes.megaType === 'SFARMMEGA') {
      this.megaTypeDesc = 'Single Family ARM';
    } else if (this.calcFeeRes && this.calcFeeRes.megaType === 'MFFIXMEGA') {
      this.megaTypeDesc = ' Multi Family Fixed Rate';
    } else if (this.calcFeeRes && this.calcFeeRes.megaType === 'MFARMMEGA') {
      this.megaTypeDesc = 'Multi Family ARM';
    }
  }

  public closeFeeSheduleModelWindow(): void {
    this.clickAccept.emit({ hidePricingWindow: true });
  }

  public editMega(): void {
    this.editPricingMegaClicked.emit({ goBackAndEdit: true });
  }

  protected trackByIdentity(_index: number, obj: any) {
    return obj;
  }
}
